export const TOGGLE_EXPANDED = 'TOGGLE_EXPANDED'
